import React, { SVGProps } from 'react';

const SvgSort3 = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' className='svg-icon' {...props}>
			<g fill='none' fillRule='evenodd'>
				<path d='M0 0h24v24H0z' />
				<path
					d='M18.5 6A1.5 1.5 0 0120 7.5v11a1.5 1.5 0 01-3 0v-11A1.5 1.5 0 0118.5 6zm-6 5a1.5 1.5 0 011.5 1.5v6a1.5 1.5 0 01-3 0v-6a1.5 1.5 0 011.5-1.5zm-6 4A1.5 1.5 0 018 16.5v2a1.5 1.5 0 01-3 0v-2A1.5 1.5 0 016.5 15z'
					fill='currentColor'
				/>
			</g>
		</svg>
	);
};

export default SvgSort3;
